<template>
  <div class="wrap">
    <div class="main">
      <div class="title">请填写以下信息提交</div>
      <div class="descripe">
        非常抱歉给你带来不便，我们重视每一位用户的体验，请填写信息帮助我们明确问题。
      </div>
      <div class="reason">
        <div class="reason-title">{{ appeal_name }}</div>
        <textarea
          class="fill-textarea"
          v-model="appeal_desc"
          maxlength="200"
          name=""
          id=""
          cols="30"
          rows="10"
          auto
          placeholder="请填写投诉原因，以便我们核实情况"
        ></textarea>
        <div class="count-num">{{ appeal_desc.length || 0 }}/200</div>
      </div>
      <div class="pic-box">
        <div class="pic-title">证据截图({{ imgList.length }}/4)</div>
        <van-uploader
          class="custom-uploader"
          :deletable="false"
          :before-read="beforeRead"
          :after-read="afterRead"
          :max-count="4"
          multiple
          accept="image/png, image/jpeg"
          v-model="imgList"
        >
          <template #preview-cover="{ file }">
            <div
              @click.stop="deletePic(file)"
              class="preview-cover van-ellipsis"
            >
              删除
            </div>
          </template>
          <div class="pic-item">
            <img :src="coverImg" class="pic" />
            <span class="desc">图片</span>
          </div>
        </van-uploader>
      </div>
      <div class="phone-input">
        <span class="label-left">联系电话</span><input v-model="phone" placeholder="请输入手机号" type="text" />
      </div>
      <div class="btn">
        <div class="l" @click="save">提交</div>
        <div class="r" @click="back">返回</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getToken, reLogin } from "@/utils/common";
import questionOnly from "@/utils/questionOnly";
import { Toast } from "vant";
import { complainLists } from "@/utils/config";
import uploadHttp from "@/utils/picOnly";
import api from "@/utils/api";
import * as imageConversion from "image-conversion";
export default {
  data() {
    return {
      appeal_name: "",
      appeal_desc: "",
      imgs: [],
      order_id: "",
      phone: "",
      imgList: [],
      coverImg:
        "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-04-15/c1bac5721a0cfa68ef8cea2b7d239649.svg"
    };
  },
  mounted() {
    document.title = "投诉";
    if (this.$route.query.no) {
      this.order_id = this.$route.query.no;
      this.appeal_name = complainLists[this.$route.query.name].title;
    }
  },
  methods: {
    deletePic(file) {
      this.imgList = this.imgList.filter(item => item.file !== file);
      this.imgs = this.imgs.filter(item => item.file !== file);
    },
    beforeRead(files) {
      this.$store.commit("changeLoading", { status: true, text: "图片上传中" });
      if (files.length) {
        const compressPromises = [];
        for (const file of files) {
          const isLt1M = (file.size / 1024 / 1024) * 10 < 5;
          if (!isLt1M) {
            compressPromises.push(
              new Promise(resolve => {
                // 压缩到500KB,这里的500就是要压缩的大小,可自定义
                imageConversion.compressAccurately(file, 500).then(res => {
                  resolve(res);
                });
              })
            );
          } else {
            compressPromises.push(Promise.resolve(file));
          }
        }
        return Promise.all(compressPromises);
      } else {
        const isLt1M = (files.size / 1024 / 1024) * 10 < 5;
        if (!isLt1M) {
          let myImg = new Promise(resolve => {
            // 压缩到500KB,这里的500就是要压缩的大小,可自定义
            imageConversion.compressAccurately(files, 500).then(res => {
              resolve(res);
            });
          });
          return myImg;
        }
        return true;
      }
    },
    afterRead(files) {
      var url = api.question.upload;
      let formData = new window.FormData();
      // 判断是单张还是多张图片
      if (Array.isArray(files)) {
        // 多张图片
        for (const file of files) {
          formData.append("file", file.file);
        }
      } else {
        // 单张图片
        formData.append("file", files.file);
      }
      formData.append("access_token", getToken());
      try {
        uploadHttp.post(url, formData).then(res => {
          if (Array.isArray(files)) {
            // 多张图片
            for (let i = 0; i < files.length; i++) {
              this.imgs.push({ file: files[i].file, img: res.data.urls[i] });
            }
          } else {
            // 单张图片
            this.imgs.push({ file: files.file, img: res.data.urls[0] });
          }
          this.$store.commit("changeLoading", { status: false });
        });
      } catch (e) {
        this.$store.commit("changeLoading", { status: false });
      }
    },
    save() {
      if (this.appeal_desc == "") {
        return Toast("请填写投诉原因");
      }
      const regExp = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/;
      if (!regExp.test(this.phone)) {
        return Toast("请填写有效的手机号");
      }
      let param = {
        order_id: this.order_id,
        appeal_name: this.appeal_name,
        appeal_desc: this.appeal_desc,
        ...(this.imgs && this.imgs.length
          ? { imgs: this.imgs.map(item => item.img) }
          : {}),
        access_token: getToken(),
        phone: this.phone
      };
      questionOnly.post("/xcx/ques/v1/order/appeal", param).then(res => {
        if (res.sta == 0) {
          Toast("提交成功");
          this.$router.replace({
            name: "complainlist",
            query: { no: this.order_id }
          });
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    },
    back() {
      this.$router.replace({ name: "report", query: { no: this.order_id } });
    },
    getDetail() {
      let param = {
        order_id: this.order_id,
        page: 1,
        count: 20,
        access_token: getToken()
      };
      questionOnly.get("/xcx/ques/v1/order/appeal/detail", param).then(res => {
        if (res.sta == 0) {
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  padding: 20px 15px;
}
.title {
  font-size: 17px;
  margin-bottom: 10px;
  font-weight: bold;
}
.descripe {
  font-size: 13px;
  color: #999999;
  margin-bottom: 20px;
}
.reason {
  background: #fff;
  padding: 15px;
  border-radius: 4px;
}
.reason-title {
  font-size: 15px;
  margin-bottom: 15px;
}
.fill-textarea {
  border: 0;
  font-size: 14px;
  width: 100%;
  height: 80px;
  padding: 0;
}
.count-num {
  text-align: right;
  font-size: 14px;
  color: #999999;
}

.pic-box {
  background: #fff;
  padding: 15px;
  margin-top: 10px;
  font-size: 15px;
  border-radius: 4px;
}
.phone-input {
  display: flex;
  align-items: center;
  height: 51px;
  background: #fff;
  margin-top: 10px;
  padding-left: 15px;
  font-size: 15px;
  border-radius: 4px;
  input {
    border: 0;
    font-size: 14px;
    padding-left: 20px;
  }
}
.btn {
  display: flex;
  font-size: 16px;
  margin-top: 20px;
  div {
    flex: 1;
    height: 45px;
    border-radius: 4px;
    background: #f6f6f6;
    color: #666666;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .l {
    margin-right: 15px;
    background: #06c05f;
    color: #ffffff;
  }
}

.pic-title {
  margin-bottom: 20px;
}
.picture {
  width: 70px;
  height: 70px;
  object-fit: cover;
}

.pic-item {
  width: 70px;
  height: 70px;
  position: relative;
  background-color: #f2f2f7;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
  color: #999999;
  margin-right: 10px;
}

.pic-item:first-child {
  margin-left: 0;
}

.pic-item.active {
  width: 20px;
  height: 20px;
}

.delete-pic {
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.42);
  border-radius: 0 0 2px 2px;
  color: #fff;
  font-size: 12px;
  height: 25px;
  line-height: 25px;
  text-align: center;
}

.pic {
  width: 30px;
  height: 30px;
}

.camera-box {
  margin-bottom: 10px;
  padding: 15px;
}
.upload-box {
  width: 70px;
  height: 70px;
  overflow: hidden;
  box-sizing: border-box;
}
.pickers {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ .custom-uploader .van-uploader__file {
  width: 70px;
  height: 70px;
}
/deep/ .van-uploader__preview-image {
  width: 70px;
  height: 70px;
}
.preview-cover {
  position: absolute;
  bottom: 0;
  box-sizing: border-box;
  width: 100%;
  color: #fff;
  font-size: 12px;
  text-align: center;
  height: 25px;
  line-height: 25px;
  background: rgba(0, 0, 0, 0.42);
  border-radius: 0 0 2px 2px;
}
textarea::-webkit-resizer {
  display: none;
}
textarea::-moz-resizer {
  display: none;
}
.label-left {
  min-width: 60px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/complain.vue